var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tiptap-vuetify',_vm._g(_vm._b({staticClass:"documentacion-editor",attrs:{"placeholder":"Escribe algo…","extensions":_vm.extensions},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}},'tiptap-vuetify',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }